// extracted by mini-css-extract-plugin
export default {"popconfirmContainer":"DeleteButton_popconfirmContainer__4nYsd","confirmOverlay":"DeleteButton_confirmOverlay__Dv6bA","text":"DeleteButton_text__VFZEG"};